import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'px-8 py-2',
    featured: 'fw-bold'
  }
} satisfies CMSConfig['megaMenuL3Mobile']
